<template>
  <div class="attachment">
    <div class="form-group">
      <label class="form-control-label">Content:</label>
      <textarea v-model="comment" rows="6" class="form-control form-control-sm"></textarea>
    </div>

    <div class="form-group">
      <label class="form-control-label">Image:</label>
      <file-upload 
        :disable-preview="true"
        :file-name="'Load Image'"
        :image-class="'preview'"
        placeholder="Load Image"
        :input-class="'form-control'"
        @load="loadImage"
      />
    </div>

    <div v-if="currentNode.attachment.innerImage" class="mb-4">
      <div class="form-group">
        <label class="form-control-label">Image height:</label>
        <input v-model="height" type="text" class="form-control form-control-sm">
      </div>

      <div class="form-group">
        <label class="form-control-label">Image width:</label>
        <input v-model="width" type="text" class="form-control form-control-sm">
      </div>
      <b-button-group>
        <b-button @click.prevent="updateImageSize" variant="success" size="sm">Update Image Size</b-button>
        <b-button @click.prevent="deleteImage" size="sm" variant="danger">Delete Image</b-button>
      </b-button-group>
    </div>
  </div>
</template>

<script>
import FileUpload from 'vue-base64-file-upload'
import { formBase } from './mixins'

export default {
  mixins: [formBase,],
  components: {
    FileUpload
  },
  data() {
    return {
      width: 100,
      height: 100,
    }
  },
  computed: {
    comment: {
      get() {
        return this.currentNode.attachment.comment
      },
      set(value) {
        let currentNode = Object.assign({}, this.currentNode)
        currentNode.attachment['comment'] = value
        this.updateNode(currentNode)
        this.updateCounter()
      }
    }
  },
  methods: {
    loadImage(img) {
      let currentNode = Object.assign({}, this.currentNode)
      
      if (!currentNode.hasOwnProperty('attachment')) {
        currentNode['attachment'] = {}
      }
      
      if (img) { 
        currentNode.attachment['innerImage'] = img
        currentNode.attachment['imgWidth'] = 100 
        currentNode.attachment['imgHeight'] = 100 
      }
      this.updateNode(currentNode)
      this.updateCounter()
    }, 
    deleteImage() {
      let currentNode = Object.assign({}, this.currentNode)

      if (currentNode.hasOwnProperty('attachment') && currentNode.attachment.innerImage) {
        currentNode.attachment.innerImage = null 
        currentNode.attachment.imgWidth = null 
        currentNode.attachment.imgHeight = null 
      }
      this.updateNode(currentNode)
      this.updateCounter()
    },
    updateImageSize() {
      let currentNode = Object.assign({}, this.currentNode)

      if (!currentNode.hasOwnProperty('attachment')) { 
        currentNode['attachment'] = {}
      }

      let width = parseInt(this.width),
      height = parseInt(this.height)

      if (isNaN(height) || isNaN(width) || width === null || height === null) return

      currentNode.attachment['imgHeight'] = height
      currentNode.attachment['imgWidth'] = width 
      this.updateNode(currentNode)
      this.updateCounter()
    } 
  },
  mounted() {
    if (this.currentNode.hasOwnProperty('attachment') && this.currentNode.attachment.imgWidth && this.currentNode.attachment.imgHeight) {
      this.width = this.currentNode.attachment.imgWidth
      this.height = this.currentNode.attachment.imgHeight
    }
  }
}
</script>

<style>

</style>